import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GoogleAnalyticsService } from './shared/sharedServices/google-analytics.service';
import { decrypt, encrypt } from './utilities/utilityFunctions';
@Component({
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,

})
export class AppComponent implements OnInit, OnDestroy {
	title = 'E-Services';
	loader: boolean;
	public message;
	public deviceInfo = null;
	public isDesktopUser: boolean;
	public isiOSUser: boolean;
	public isAndroidUser: boolean;
	public isUseWebsite:boolean;
	private unsubscribe: Subscription[] = [];

	constructor(private translationService: TranslationService,
		private router: Router,
		private deviceService: DeviceDetectorService,
		private layoutConfigService: LayoutConfigService,
		private gaService: GoogleAnalyticsService,
		private splashScreenService: SplashScreenService) {
		document.addEventListener('contextmenu', event => event.preventDefault());
		this.deviceCheck();
		this.gaService.init();
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
	}

	ngOnInit(): void {
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.splashScreenService.hide();
				window.scrollTo(0, 0);
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
		});
		this.unsubscribe.push(routerSubscription);
		if(localStorage.getItem('isUseWebsite')==decrypt('1')){
			this.isUseWebsite = true;
		}
	}

	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}

	deviceCheck() {
		this.deviceInfo = this.deviceService.getDeviceInfo();
		if (this.deviceInfo.os == 'iOS') {
			this.isiOSUser = true;
			this.isAndroidUser = false;
			localStorage.setItem('agent', encrypt('ios'))
		} else if (this.deviceInfo.os == 'Android') {
			this.isAndroidUser = true;
			this.isiOSUser = false;
			localStorage.setItem('agent', encrypt('android'))

		}
		const isMobile = this.deviceService.isMobile();
		const isTablet = this.deviceService.isTablet();
		this.isDesktopUser = this.deviceService.isDesktop();
		if (this.isDesktopUser)
			localStorage.setItem('agent', encrypt('desktop'))
	}

	public useWebsite() {
		localStorage.setItem('isUseWebsite', encrypt('1'));
		this.isDesktopUser = true;

	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
	  }
}
